import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ApiWave } from "@/generated/models/ApiWave";
import { useWave } from "@/hooks/useWave";
import { MemesWaveSmallLeaderboardDrop } from "./MemesWaveSmallLeaderboardDrop";
import { DefaultWaveSmallLeaderboardDrop } from "./DefaultWaveSmallLeaderboardDrop";
interface WaveSmallLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const WaveSmallLeaderboardDrop: React.FC<WaveSmallLeaderboardDropProps> = t0 => {
  const $ = _c(8);
  const {
    drop,
    wave,
    onDropClick
  } = t0;
  const {
    isMemesWave
  } = useWave(wave);
  if (isMemesWave) {
    let t1;
    if ($[0] !== drop || $[1] !== onDropClick || $[2] !== wave) {
      t1 = <MemesWaveSmallLeaderboardDrop drop={drop} wave={wave} onDropClick={onDropClick} />;
      $[0] = drop;
      $[1] = onDropClick;
      $[2] = wave;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  } else {
    let t1;
    if ($[4] !== drop || $[5] !== onDropClick || $[6] !== wave) {
      t1 = <DefaultWaveSmallLeaderboardDrop drop={drop} wave={wave} onDropClick={onDropClick} />;
      $[4] = drop;
      $[5] = onDropClick;
      $[6] = wave;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    return t1;
  }
};